import { render, staticRenderFns } from "./TestStatusesComponent.vue?vue&type=template&id=3f6dfb63"
import script from "./TestStatusesComponent.vue?vue&type=script&lang=js"
export * from "./TestStatusesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../HCP/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports